import type { ToRefs, DeepReadonly } from 'vue'
import { reactive, readonly, toRefs } from 'vue'

import type { Option } from '~/components/VDropdown.vue'

type State = {
  options: Option[]
  currentOption: Option | null
}

export type UseDropdown<T> = {
  selectOption: (option: Option | null) => void
  loadOptions: (data: T[]) => void
} & ToRefs<DeepReadonly<State>>

export function useDropdown<T>({ reducer }: { reducer: (acc: Option[], data: T) => Option[] }): UseDropdown<T> {
  const state = reactive<State>({
    options: [],
    currentOption: null,
  })

  function loadOptions(data: T[] | undefined) {
    if (!data) return

    state.options = data.reduce(reducer, [])
    state.currentOption = state.options[0] ?? null
  }

  function selectOption(option: Option | null) {
    state.currentOption = option
  }

  return {
    ...toRefs(readonly(state)),
    selectOption,
    loadOptions,
  }
}
